import type GUI from "lil-gui";
import * as THREE from "three";
import Experience from "../Experience";
import type Debug from "../utils/Debug";
import type Resources from "../utils/Resources";

export default class Environment {
  experience: Experience;
  resources: Resources;
  scene: THREE.Scene;
  debug: Debug;
  debugFolder: GUI | undefined;

  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.debug = this.experience.debug;
    this.resources = this.experience.resources;

    if (this.debug.ui) {
      this.debugFolder = this.debug.ui.addFolder("environment");
    }
    this.setLight();
  }

  setLight() {
    const ambientLight = new THREE.AmbientLight("#FFFFFF", 1.5);
    this.scene.add(ambientLight);

    // Main directional light from top-right
    const directionalLight = new THREE.DirectionalLight(0xffffff, 1.8);
    directionalLight.position.set(100, 100, 60);
    directionalLight.target.position.set(0, 0, -5);
    directionalLight.shadow.mapSize.width = 1024;
    directionalLight.shadow.mapSize.height = 1024;

    // // How far/near the shadow camera will render
    directionalLight.shadow.camera.near = 0.1;
    directionalLight.shadow.camera.far = 1000;

    this.scene.add(directionalLight);
    this.scene.add(directionalLight.target);
    // // Debug helpers
    if (this.debugFolder) {
      const dirHelper = new THREE.DirectionalLightHelper(directionalLight, 1);
      this.scene.add(dirHelper);
    }
  }
}
